/** Localized pricing tier display helpers. */

export function formatPropertyLimit(t, max) {
  if (max == null) return t('pricing.limits.unlimitedProperties');
  if (max === 1) return t('pricing.limits.oneProperty');
  return t('pricing.limits.propertyCount', { count: max });
}

export function formatNotificationLimit(t, max) {
  if (max == null) return t('pricing.limits.unlimitedNotifications');
  return t('pricing.limits.notificationCount', { count: max });
}

export function getTierDisplayName(t, tier) {
  const key = `pricing.tierNames.${tier.slug}`;
  const localized = t(key);
  return localized !== key ? localized : tier.display_name;
}

/** Extra feature bullets only (limits + AI shown separately in the card). */
export function getTierExtraFeatures(t, tier) {
  const key = `pricing.tierExtras.${tier.slug}`;
  const extras = t(key);
  if (Array.isArray(extras)) return extras;
  return [];
}
